import { useColorMode, useColorStyle } from '@tonic-one/react';

const useBlockTitleStyle = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  return {
    color: colorStyle.color.emphasis,
    textAlign: 'left',
    fontSize: '16px',
    lineHeight: '22px',
    fontWeight: '600',
    margin: '1em 0',
  };
};

export { useBlockTitleStyle };
